import TextField from "@mui/material/TextField";
import EmailIcon from "@mui/icons-material/Email";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";

interface InputPasswordProps {
  label: string;
  handleChange?: any;
  name?: string;
  value?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
}

const InputPassword = ({
  label,
  handleChange,
  name,
  value,
  onKeyDown,
}: InputPasswordProps) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#33BBED",
      },
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            width: "100%", // Tornando o TextField 100% de largura
          },
        },
      },
    },
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  return (
    <ThemeProvider theme={theme}>
      <TextField
        onChange={(e: any) => handleChange(e.target.value, name)}
        name={name}
        value={value}
        id="demo-helper-text-misaligned"
        label={label}
        onKeyDown={onKeyDown}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "5px", 
            backgroundColor: "#FFF",
          },
        }}
        type={showPassword ? "text" : "password"}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
          style: {
            // borderRadius: "10px",
            // fontFamily: "Aeonik",
          },
        }}
      />
    </ThemeProvider>
  );
};

export default InputPassword;
